import i18next from 'i18next';

i18next.addResources('es_CL', 'DatePicker', {
  invalidDate: 'La fecha ingresada no es válida'
});

i18next.addResources('pt_PT', 'Cart', {
  invalidDate: 'A data inserida não é válida'
});
